import { Input } from "@components/global/new/Input/Input";
import MinerEfficiencyEditor from "@components/global/new/MinerEfficiencyEditor/MinerEfficiencyEditor";
import { IMinerProfileEditorStore } from "@mobx/store/minerProfiles/editor";
import { IMinerProfileMeta } from "@services/minerProfiles";
import { observer } from "mobx-react-lite";
import { useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import MobxMinerViewBlock from "./MobxMinerViewBlock";
import styles from "./MinerProfileFields.module.scss";
import { IMinerProfileFieldsProps } from "./MinerProfileFields.props";

function MinerProfileFields2(
  props: IMinerProfileFieldsProps & {
    readonly editorStore: IMinerProfileEditorStore;
  }
) {
  const additional: IMinerProfileMeta = useMemo(() => {
    if (typeof props.currentProfile?.meta === "string") {
      return JSON.parse(props.currentProfile?.meta || "{}");
    }
    return props.currentProfile?.meta || {};
  }, [props.currentProfile?.meta]);
  const currentProfile = useMemo(() => {
    if (!props.currentProfile) return;
    return {
      ...props.currentProfile,
      meta: additional,
    };
  }, [additional, props.currentProfile]);
  const { formatMessage } = useIntl();
  const draft = props.editorStore.draft;

  useEffect(() => {
    if (currentProfile) {
      props.editorStore.loadProfile(currentProfile);
      return;
    }

    props.editorStore.createEmpty();
  }, [currentProfile, props.reset, props.editorStore]);

  const checkErrors = (name: string) => {
    if (!props.errors) return false;
    return !!props.errors[name];
  };

  return (
    <div className={styles.wrapper}>
      <MobxMinerViewBlock
        editorStore={props.editorStore}
        disabled={props.disabled}
        checkErrors={checkErrors}
      />
      <div className={styles.content}>
        <Input
          type="text"
          size="small"
          label={
            <span className={styles.label}>
              {formatMessage({ id: "contracts.info.name" })}
            </span>
          }
          outlined={!props.disabled}
          readOnly={props.disabled}
          value={draft?.name || ""}
          onChange={(e) => props.editorStore.setName(e.target.value)}
          status={(checkErrors("name") && "error") || ""}
          autoComplete="off"
          id="name"
        />
        <MinerEfficiencyEditor
          editorStore={props.editorStore}
          disabled={props.disabled}
          outlined={!props.disabled}
          perfError={checkErrors("perfomance")}
          consumptionError={checkErrors("consumpation")}
          efficiencyError={checkErrors("efficiency")}
          algoError={checkErrors("hash")}
        />
      </div>
    </div>
  );
}

export default observer(MinerProfileFields2);
